class ThemePopupScrubber extends HTMLElement {
  constructor() {
    super();
    this.items = Array.from(this.querySelectorAll('[data-theme-popup-scrubber-item]'));
    this.templates = this.items.map((item) => item.querySelector('template'));
    this.templates.forEach(template => template.remove());
  }

  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    //
    this.items.forEach((item, i) => {
      const overlay = item.querySelector('[data-theme-popup-scrubber-overlay]');
      const openEls = item.querySelectorAll('[data-theme-popup-scrubber-item-open-action]');
      const closeEl = item.querySelector('[data-theme-popup-scrubber-overlay-close-button]');
      const scrubberParent = overlay.lastElementChild.firstElementChild;
      //
      const openOverlay = () => {
        if (!scrubberParent.firstElementChild)  scrubberParent.innerHTML = this.templates[i].innerHTML;
        overlay.classList.add('theme-popup-scrubber-overlay--active');
        if (overlay.dataset.autoplay == 'true') scrubberParent.firstElementChild.play();
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.paddingRight = '15px';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.zIndex = '0';
      };

      openEls.forEach(openEl => {
        openEl.addEventListener('click', openOverlay, { signal });
      });
      //
      closeEl.addEventListener('click', () => {
        const scrollY = document.body.style.top;
        document.body.style.paddingRight = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        document.body.style.zIndex = '';
        window.scrollTo({top: parseInt(scrollY || '0') * -1, behavior: 'instant'});
        overlay.classList.remove('theme-popup-scrubber-overlay--active');
        scrubberParent.firstElementChild.pause();
      }, { signal});
    })
  }

  disconnectedCallback() {
    this.abortController.abort();
    this.abortController = null;
  }

}

customElements.define('theme-popup-scrubber', ThemePopupScrubber);
